// Function to handle pagination click events
function handlePaginationClick(event) {
  event.preventDefault();

  const url = new URL(event.currentTarget.href);
  const section = document.getElementById('product-grid').dataset.id;

  // Show loading state
  document.querySelector('.loading-overlay').classList.add('active');

  fetch(`${url.pathname}${url.search}&section_id=${section}`)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');

      // Update product grid
      document.getElementById('product-grid').innerHTML = html.getElementById('product-grid').innerHTML;

      // Update pagination
      const newPagination = html.querySelector('.pagination');
      if (newPagination) {
        document.querySelector('.pagination').innerHTML = newPagination.innerHTML;
      }

      // Update URL without reload
      history.pushState({ path: url.href }, '', url.href);

      // Re-attach click handlers to new pagination links
      attachPaginationHandlers();
    })
    .catch((error) => {
      console.error('Error loading page:', error);
    })
    .finally(() => {
      // Hide loading state
      document.querySelector('.loading-overlay').classList.remove('active');
      // Scroll to top of grid
      document.getElementById('product-grid').scrollIntoView({ behavior: 'smooth' });
    });
}

// Function to attach click handlers to pagination links
function attachPaginationHandlers() {
  const paginationLinks = document.querySelectorAll('.pagination__list a');
  paginationLinks.forEach((link) => {
    link.removeEventListener('click', handlePaginationClick);
    link.addEventListener('click', handlePaginationClick);
  });
}

// Initialize pagination handlers
attachPaginationHandlers();

// Listen for back/forward browser navigation
window.addEventListener('popstate', () => {
  const url = new URL(window.location);
  const section = document.getElementById('product-grid').dataset.id;

  document.querySelector('.loading-overlay').classList.add('active');

  fetch(`${url.pathname}${url.search}&section_id=${section}`)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      document.getElementById('product-grid').innerHTML = html.getElementById('product-grid').innerHTML;

      const newPagination = html.querySelector('.pagination');
      if (newPagination) {
        document.querySelector('.pagination').innerHTML = newPagination.innerHTML;
      }

      attachPaginationHandlers();
    })
    .catch((error) => console.error('Error loading page:', error))
    .finally(() => {
      document.querySelector('.loading-overlay').classList.remove('active');
      document.getElementById('product-grid').scrollIntoView({ behavior: 'smooth' });
    });
});
